import tw from "twin.macro";
import { Loader2, Pause } from "lucide-react";

function EmergencyStopButton({
  disabled,
  loading,
  label,
  onClick,
}: {
  disabled: boolean;
  loading?: boolean;
  label: string;
  onClick?: () => void;
}) {
  return (
    <button
      type="button"
      css={[
        tw`w-full flex items-center justify-center gap-2 m-1 min-w-[130px]`,
        tw`rounded-3xl min-h-[40px] p-1`,
        // Couleurs "urgence" : rouge de base, accent orange à l'appui.
        tw`bg-modules-redBase text-white`,
        tw`ring-2 ring-orange-400/40`,
        tw`shadow-md`,
        tw`transition transform duration-100`,
        tw`active:scale-100 active:bg-orange-400 active:transition active:transform active:duration-100`,
        tw`disabled:opacity-40 disabled:cursor-not-allowed disabled:active:scale-100`,
        // Promotion GPU pour éviter que iOS Safari ne recompose le `shadow-md`
        // à chaque frame quand le panel du BottomSheet anime son `translateY`.
        { transform: "translateZ(0)" },
      ]}
      disabled={disabled}
      onClick={onClick ?? undefined}
    >
      {loading ? (
        <Loader2 tw="h-5 w-5 text-white animate-spin" />
      ) : (
        <Pause tw="h-5 w-5 text-white" fill="white" strokeWidth={0.25} />
      )}
      <p css={[tw`text-lg font-normal`]}>{label}</p>
    </button>
  );
}

export default EmergencyStopButton;
